import React, { Component } from "react";
import { Link, withRouter } from "react-router-dom";
import Exercises from "../../data/Exercises.json";
import ExercisesSolution from "../../data/ExercisesSolution.json";
import Deducer from "../Calcul Tools/Deducer";

// Navigation arrow component remains the same
const NavigationArrow = ({
  direction,
  currentExercise,
  disabled,
  onNavigate,
}) => {
  const icon = `fas fa-arrow-${direction}`;
  const targetExercise =
    direction === "left"
      ? Number(currentExercise - 1)
      : Number(currentExercise + 1);

  if (disabled) {
    return (
      <i className={`icon calculus-header--icon-menu ${icon} deactivated`} />
    );
  }

  return (
    <Link to={`/calcul-prop/${targetExercise}`} onClick={onNavigate}>
      <i className={`icon calculus-header--icon-menu ${icon}`} />
    </Link>
  );
};

const CalculusHeader = ({ currentExercise, onNavigate }) => {
  const isFirstExercise = currentExercise === 1;
  const isLastExercise = currentExercise === Exercises.length;

  return (
    <ul className="calculus-header colorInterface">
      <li className="calculus-header-TextAndIcon">
        <Link to="/">
          <i className="icon calculus-header--icon-menu fas fa-arrow-circle-left" />
        </Link>
        <Link to="/calcul-prop-exo">
          <i className="icon calculus-header--icon-menu fas fa-th" />
        </Link>
      </li>
      <li>
        <h3>Calcul des propositions</h3>
      </li>
      <li>
        <span className="calculus-header-TextAndIcon">
          <NavigationArrow
            direction="left"
            currentExercise={currentExercise}
            disabled={isFirstExercise}
            onNavigate={onNavigate}
          />
          Ex. {currentExercise}
          <NavigationArrow
            direction="right"
            currentExercise={currentExercise}
            disabled={isLastExercise}
            onNavigate={onNavigate}
          />
        </span>
      </li>
    </ul>
  );
};

class CalculDesPropositions extends Component {
  // Store parentCallback as a class property instead of a local variable
  parentCallback = null;

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyDown);
  }

  componentWillUnmount() {
    document.removeEventListener("keydown", this.handleKeyDown);
  }

  // Method to set the callback from the Deducer component
  setParentCallback = (fn) => {
    this.parentCallback = fn;
  };

  // Navigation function that will be used for both click and keyboard events
  onNavigate = () => {
    // Now this can access this.parentCallback properly
    if (this.parentCallback) {
      this.parentCallback();
    }
  };

  handleKeyDown = (e) => {
    const { num } = this.props.match.params;
    const exerciseNumber = Number(num);

    if (e.key === "ArrowLeft" && exerciseNumber > 1) {
      // First call the navigation function to trigger any callbacks
      this.onNavigate();
      // Then navigate to the previous exercise
      this.props.history.push(`/calcul-prop/${exerciseNumber - 1}`);
    } else if (e.key === "ArrowRight" && exerciseNumber < Exercises.length) {
      this.onNavigate();
      this.props.history.push(`/calcul-prop/${exerciseNumber + 1}`);
    }
  };

  render() {
    const exerciseNumber = Number(this.props.match.params.num);

    if (
      isNaN(exerciseNumber) ||
      exerciseNumber < 1 ||
      exerciseNumber > Exercises.length
    ) {
      return (
        <main
          className="deducer-workspace colorInterfaceGrey"
          style={{
            margin: "180px 0px 180px 0px",
            alignContent: "center",
            justifyContent: "center",
            textAlign: "center",
          }}
        >
          Erreur du paramètre dans la barre d'adresse.
          <br />
          Veuillez entrer un nombre entier positif, inférieur ou égal
          <br />
          au nombre actuel d'exercices, c'est-à-dire {Number(Exercises.length)}.
        </main>
      );
    } else {
      return (
        <main className="calculus-workspace">
          <CalculusHeader
            currentExercise={exerciseNumber}
            onNavigate={this.onNavigate}
          />
          <Deducer
            pageName="Calcul des propositions"
            exerciseNumber={exerciseNumber}
            exerciseData={Exercises}
            exerciseSolutionData={ExercisesSolution}
            // Use the class method to store the callback
            setCallback={this.setParentCallback}
          />
        </main>
      );
    }
  }
}

// Export with withRouter to have access to history, location, match props
export default withRouter(CalculDesPropositions);



// WEBPACK FOOTER //
// ./src/components/Pages/CalculDesPropositions.js